import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyNumberMessage, PropertyNumberMessageSplitted } from '@shared-ui/lodging-property-details';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const PropertyNumberWrapper = ({
  inputs
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSSpacing, {
    margin: {
      blockend: 'four',
      blockstart: 'two'
    }
  }, React.createElement("div", null, React.createElement(PropertyNumberMessage, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      blockend: 'four',
      blockstart: 'two'
    }
  }, React.createElement("div", null, React.createElement(PropertyNumberMessageSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))));
};
export const SharedUiPropertyNumberWrapper = withSharedUiPropertyDetails(PropertyNumberWrapper);
SharedUiPropertyNumberWrapper.displayName = 'SharedUiPropertyNumberWrapper';